module.exports = __webpack_public_path__ + "static/media/badge-icon.105e724a.svg";